<template>
  <div class="table-box">
    <global-tag>
      <el-form label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="服务类别：">
              <el-select v-model="searchObj.serviceTypeId" placeholder="请选择">
                <el-option
                  v-for="item in serviceTypeList"
                  :key="item.id"
                  :label="item.serviceTypeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="服务项目：">
              <el-input
                clearable
                placeholder="请输入"
                v-model="searchObj.serviceProductName"
                size="primary"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="search">
            <el-form-item label="所属机构:" prop="serviceStation">
              <el-select v-model="searchObj.serviceStation" placeholder="请选择" size="mini" filterable style="height:40px;line-height:40px;width: 100%">
                <el-option v-for="item in serviceStationList" :key="item.selectTreeId" :label="item.statName"
                  :value="item.selectTreeId">
                </el-option>
              </el-select>
            </el-form-item>
           </el-col>
          <el-col :span="3" :offset="2">
            <el-button
              type="primary"
              size="medium"
              class="searchBtns"
              @click="getTableData"
              >查询
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </global-tag>

    <el-button
      icon="el-icon-plus"
      class="openBtns"
      style="margin: 10px 0"
      type="success"
      size="medium"
      @click="showDialog('新增')"
    >
      新增
    </el-button>

    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-bottom: 15px"
      ref="addForm"
      :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
    >
      <el-table-column
        type="index"
        width="70"
        label="序号"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="serviceTypeName"
        label="服务类别"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="serviceProductName"
        label="服务项目"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="servePrice"
        label="服务价格"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="discountPrice"
        label="折后价格"
        align="center"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column 
        prop="buyType"
        label="购买类型"
        align="center"
        :show-overflow-tooltip="true"
      >
       <template slot-scope="scope">
         <span v-if="scope.row.buyType=='1'">政府购买</span>
         <span v-else>商业购买</span>
       </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <el-switch
            active-value="1"
            inactive-value="0"
            @change="onStatusChange(scope.row)"
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="机构"
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button @click="showDialog('查看', scope.row.id)" type="text"
            >查看
          </el-button>
          <el-button @click="showDialog('编辑', scope.row.id)" type="text"
            >编辑
          </el-button>
          <el-button @click="deleteItem(scope.row.id)" type="text"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageConfig.pageNo"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageConfig.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageConfig.total"
    >
    </el-pagination>

    <!-- 表单弹框-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :disabled="dialogTitle === '查看'"
        :model="addForm"
        :rules="rules"
        ref="addForm"
        label-width="80px"
      >
        <el-form-item label="服务类别:" prop="serviceTypeId">
          <el-select
            style="width: 100%"
            v-model="addForm.serviceTypeId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in serviceTypeList"
              :key="item.id"
              :label="item.serviceTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务项目:" prop="serviceProductName">
          <el-input
            v-model="addForm.serviceProductName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务价格:" prop="servePrice">
          <el-input
            v-model="addForm.servePrice"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="折后价:" prop="discountPrice">
          <el-input
            v-model="addForm.discountPrice"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务内容:" prop="serviceText">
          <el-input
            v-model="addForm.serviceText"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
            <el-form-item label="服务时长:" prop="period">
          <el-input
            v-model="addForm.period"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
         <el-form-item label="购买类型:" prop="buyType">
          <el-select
            style="width: 100%"
            v-model="addForm.buyType"
            placeholder="请选择"
          >
            <el-option
              v-for="item in buyTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片:" prop="productPhoto">
          <el-upload
            :action="baseUrl"
            :show-file-list="false"
            :on-success="
              (file, fileList) => {
                handleAvatarSuccess(file, fileList, 'add')
              }
            "
          >
            <div class="avatar" v-if="addForm.productPhoto">
              <img alt :src="addForm.productPhoto" />
            </div>
            <div style="height: 102px" v-else>
              <i class="el-icon-plus avatar_uploader avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="状态:" prop="status">
          <el-radio-group v-model="addForm.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div
        v-if="dialogTitle !== '查看'"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 15px;
        "
      >
        <el-button @click="send" type="primary">确定</el-button>
        <el-button @click="handleClose" type="info">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headLine from "../components/headline"
import baseURL from "@/api/baseURL"

export default {
  components: {
    headLine,
  },
  data() {
    return {
      // 服务类别列表
      serviceTypeList: [],
      // 图片上传地址
      baseUrl: baseURL + "/jjyl/controller/uploadController/info/uploadPhoto",
      searchObj: {
        serviceTypeId: "",
        serviceProductName: "",
      },
      dialogTitle: "",
      dialogVisible: false,
      buyTypeList:[{
        name:'政府购买',
        id:'1'
      },{
        name:'商业购买',
        id:'2'
      }],
      editId: "",
      addForm: {
        serviceTypeId: "",
        serviceProductName: "",
        servePrice: "",
        status: "1",
        productPhoto: "",
      },
      rules: {
        type: [
          {
            required: true,
            message: "请选择服务类别",
            trigger: "blur",
          },
        ],
        item: [
          {
            required: true,
            message: "请输入服务项目",
            trigger: "blur",
          },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
      tableData: [],
      // 分页
      pageConfig: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      isSearchContent: true,
      serviceStationList:[]
    }
  },
  computed: {
    serviceType() {
      return function (id) {
        let serviceTypeList = this.serviceTypeList.find(
          (item) => item.id === id
        )
        return serviceTypeList ? serviceTypeList.serviceTypeName : ""
      }
    },
  },
  created() {
    this.getTableData()
    this.getTreeChecked()
    this.$http
      .request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 1000,
        },
      })
      .then((res) => {
        if (res.code === 200) {
          res.content.list.forEach((item) => {
            console.log(item.status)
            if (item.status == 1) {
              this.serviceTypeList.push(item)
            }
          })
          console.log(this.serviceTypeList)
        }
      })
  },
  methods: {
    getTreeChecked(id) {
      this.$http
        .request({
          url: "/jjyl/admin/serviceStation/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              return
            }
            this.serviceStationList = res.content.list.map((item) => {
              return {
                selectTreeId: item.id, //id
                statName: item.statName,
              }
            })
          }
        })
    },
    Reset() {
      this.searchObj = {}
      this.getTableData()
    },
    // 数据状态发生改变
    onStatusChange(row) {
      this.$http
        .request({
          url: "/jjyl/admin/product/info/insert",
          method: "POST",
          data: {
            status: row.status,
            id: row.id,
            serviceTypeId: row.serviceTypeId,
            productPhoto: row.productPhoto,
            serviceProductName: row.serviceProductName,
          },
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`修改状态成功`)
          } else {
            this.$message.success(`修改状态失败`)
          }
          this.getTableData()
        })
    },
    // 提交
    send() {
      this.$refs.addForm.validate((valid) => {
        // 校验通过
        if (valid) {
          let data = {
            serviceTypeId: this.addForm.serviceTypeId,
            status: this.addForm.status,
            productPhoto: this.addForm.productPhoto,
            serviceProductName: this.addForm.serviceProductName,
            ...this.addForm,
          }

          if (this.editId) {
            data.id = this.editId
          }
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          })
          this.$http
            .request({
              url: "/jjyl/admin/product/info/insert",
              method: "POST",
              data: data,
            })
            .then((res) => {
              if (res.code == 200) {
                loading.close()
                this.$message.success("操作成功")
                this.editId = ""
                this.handleClose()
                this.getTableData()
              } else {
                loading.close()
              }
            })
            .catch((error) => {
              loading.close()
              this.handleClose()
            })
        }
      })
    },
    // 删除某一项
    deleteItem(id) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .request({
            url: "/jjyl/admin/product/info/deleteById",
            method: "POST",
            data: {
              id,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功")
              this.getTableData()
            }
          })
      })
    },
    // 显示弹框
    showDialog(title, id) {
      this.dialogTitle = title
      this.dialogVisible = true

      if (id) {
        this.editId = id
      }

      if (title != "新增") {
        this.$http
          .request({
            url: "/jjyl/admin/product/info/findById",
            method: "POST",
            data: {
              id: id,
            },
          })
          .then((res) => {
            if (res.code === 200) {
              this.addForm = res.content || {}
            }
          })
      }
    },
    // 关闭弹框
    handleClose() {
      this.dialogVisible = false
      this.addForm = {}
      this.$refs.addForm.resetFields()
    },
    //自定义图片上传
    handleAvatarSuccess(res) {
      if (res.code === 200 && res.content) {
        this.$set(this.addForm, "productPhoto", res.content)
      }
    },
    // 获取列表数据
    getTableData() {
      this.$http
        .request({
          url: "/jjyl/admin/product/info/findList",
          method: "POST",
          data: {
            pageNo: this.pageConfig.pageNo,
            pageSize: this.pageConfig.pageSize,
            serviceTypeId: this.searchObj.serviceTypeId,
            serviceProductName: this.searchObj.serviceProductName,
            serviceStation:this.searchObj.serviceStation
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (!res.content) {
              this.tableData = []
              this.pageConfig.total = 0
            } else {
              this.tableData = res.content.list || []
              this.pageConfig.total = res.content.count || 0
            }
          }
        })
    },
    // 每页显示条数切换
    handleSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getTableData()
    },
    // 页码切换
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 100px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;

    img {
      width: 100px;
      height: 100px;
      line-height: 100px;
      display: block;
    }
  }
}

.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}
</style>
